<template>
    <kt-panel>
        <kt-panel-body>
            <form id="add_corporate_form">
                <kt-row>
                    <kt-col lg="4" md="6" sm="12">
                        <kt-form-group>
                            <kt-form-label for="business_name">
                                {{ $t('label.business_name') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="business_name"
                                    name="business_name"
                                    v-model="form_data.business_name"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" sm="12">
                        <kt-form-group>
                            <kt-form-label for="psp">
                                {{ $t('label.psp') }}
                            </kt-form-label>
                            <kt-form-select size="4" id="psp" name="psp" v-model="form_data.psp">
                                <option
                                        v-bind:key="index"
                                        v-for="(psp, index) in activeBillPsp"
                                        v-bind:value="psp.value"
                                        :selected="psp.value"
                                >
                                    {{ psp.title }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" sm="12">
                        <kt-form-group>
                            <kt-form-label for="status">
                                {{ $t('label.status') }}
                            </kt-form-label>
                            <kt-form-select size="4" id="status" name="status" v-model="form_data.status">
                                <option
                                        v-bind:key="index"
                                        v-for="(status, index) in statuses"
                                        v-bind:value="status.value"
                                        :selected="status.value"
                                >
                                    {{ status.name }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <pasargad
                        v-if="form_data.psp == pspList.PASARGAD"
                        :form_data="form_data"
                ></pasargad>
                <mellat
                        v-if="form_data.psp == pspList.MELLAT"
                        :form_data="form_data"
                ></mellat>
                <kt-form-action class="mt-4">
                    <button
                            id="submit_btn"
                            class="btn btn-md btn-success btn-wide"
                            @click.prevent="addCorporate"
                    >
                        {{ $t('btn.submit') }}
                    </button>
                </kt-form-action>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>

<script>

import {i18n} from '@/plugins/i18n'
import {dedicatedStatusStr, dedicatedStatus} from '@/constants/dedicatedStatus'
import pasargad from './psp_corporate_data_forms/pasargad'
import mellat from './psp_corporate_data_forms/mellat'
import $ from "jquery";
import {pspList, activeBillPsp} from '@/constants/psp'
import toastr from "toastr";

export default {
    props: {
        submit: {
            default: () => {
                return {}
            },
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        },
    },
    data() {
        return {
            shebas: {
                'percent': '',
                'number': ''
            },
            has_failed_to_sync_sheba_numbers: false,
            failed_to_sync_sheba_numbers: null,
            collective: {},
            percent: 0,
            activeBillPsp,
            statuses: [
                {
                    name: dedicatedStatusStr.ACTIVE,
                    value: dedicatedStatus.ACTIVE
                },
                {
                    name: dedicatedStatusStr.PENDING,
                    value: dedicatedStatus.PENDING
                },
                {
                    name: dedicatedStatusStr.REJECTED,
                    value: dedicatedStatus.REJECTED
                },
                {
                    name: dedicatedStatusStr.BLOCKED,
                    value: dedicatedStatus.BLOCKED
                },
                {
                    name: dedicatedStatusStr.SEND_TO_PSP,
                    value: dedicatedStatus.SEND_TO_PSP
                },
                {
                    name: dedicatedStatusStr.REJECTED_BY_PSP,
                    value: dedicatedStatus.REJECTED_BY_PSP
                },
            ],
            pspList,
        }
    },
    components: {
        pasargad,
        mellat
    },
    mounted() {
        if (this.form_data.sheba_numbers) {
            this.shebas = this.form_data.sheba_numbers
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    methods: {
        addCorporate() {
            let form = $('#add_corporate_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    account_number: {
                        required: () => {
                            if (this.form_data.psp == this.pspList.PASARGAD) return true;
                        }
                    },
                    sheba_number: {
                        required: () => {
                            if (this.form_data.psp == this.pspList.PASARGAD) return true;
                        }
                    },
                    business_name: {
                        required: () => {
                            if (this.form_data.psp == this.pspList.PASARGAD) return true;
                        }
                    },
                    guild_id: {
                        required: () => {
                            if (this.form_data.psp == this.pspList.PASARGAD) return true;
                        }
                    },
                    mobile: {
                        required: () => {
                            if (this.form_data.psp == this.pspList.PASARGAD) return true;
                        }
                    },

                    password: {
                        required: () => {
                            if (this.form_data.psp == this.pspList.PASARGAD) return true;
                        }
                    },

                    username: {
                        required: () => {
                            if (this.form_data.psp == this.pspList.PASARGAD) return true;
                        }
                    },
                    psp: {
                        required: true
                    },

                    national_code: {
                        required: () => {
                            if (this.form_data.psp == this.pspList.PASARGAD) return true;
                        }
                    },
                    mellat_bill_code: {
                        required: () => {
                            if (this.form_data.psp == this.pspList.MELLAT) return true;
                        }
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            if (!this.checkIfIsEnglish(this.form_data.username)) {
                form.validate().showErrors({
                    username: i18n.t('pos.validations.enter_english')
                })
                return;
            }
            this.submit(form, btn)
        },
        checkIfIsEnglish(value) {
            if (!value || value == 'null') return true;

            let regex = /^[a-zA-Z0-9?><;,{}[\]\-_+=!@#$%\^&*|']*$/;

            return regex.test(value)
        },
    }
}
</script>

<style>
.color-novin {
    color: #683f84;
}

.color-mellat {
    color: #ed1b2f;
}

.color-saman {
    color: #07abea;
}

.color-parsian {
    color: #9c0f1e;
}

.color-pasargad {
    color: #f58500;
}
</style>